export class CarNumber {
	
	constructor() {
		// Таблица транслитерации русских букв в латинские (похожие по написанию)
		// Для номеров машин используем только одиночные буквы
		this.translitMap = {
			'Й': 'Y', 'Ц': 'C', 'У': 'Y', 'К': 'K', 'Е': 'E', 'Н': 'H',
			'Г': 'G', 'Ш': 'S', 'Щ': 'S', 'З': 'Z', 'Х': 'X', 'Ъ': '',
			'Ф': 'F', 'Ы': 'Y', 'В': 'B', 'А': 'A', 'П': 'P', 'Р': 'P',
			'О': 'O', 'Л': 'L', 'Д': 'D', 'Ж': 'Z', 'Э': 'E', 'Я': 'A',
			'Ч': 'C', 'С': 'C', 'М': 'M', 'И': 'I', 'Т': 'T', 'Ь': '',
			'Б': 'B', 'Ю': 'Y', 'Ё': 'E',
			// Строчные
			'й': 'Y', 'ц': 'C', 'у': 'Y', 'к': 'K', 'е': 'E', 'н': 'H',
			'г': 'G', 'ш': 'S', 'щ': 'S', 'з': 'Z', 'х': 'X', 'ъ': '',
			'ф': 'F', 'ы': 'Y', 'в': 'B', 'а': 'A', 'п': 'P', 'р': 'P',
			'о': 'O', 'л': 'L', 'д': 'D', 'ж': 'Z', 'э': 'E', 'я': 'A',
			'ч': 'C', 'с': 'C', 'м': 'M', 'и': 'I', 'т': 'T', 'ь': '',
			'б': 'B', 'ю': 'Y', 'ё': 'E'
		};
	}

	/**
	 * Транслитерирует русские буквы в латинские и оставляет только буквы и цифры
	 * Все буквы преобразуются в заглавные
	 * @param {string} value - исходное значение
	 * @returns {string} - обработанное значение
	 */
	transliterate(value) {
		if (!value) return '';
		
		let result = '';
		
		for (let i = 0; i < value.length; i++) {
			let char = value[i];
			
			// Если это русская буква - транслитерируем (результат уже в верхнем регистре)
			if (this.translitMap[char] !== undefined) {
				result += this.translitMap[char];
			}
			// Если это латинская буква - преобразуем в заглавную
			else if (/[A-Za-z]/.test(char)) {
				result += char.toUpperCase();
			}
			// Если это цифра - оставляем как есть
			else if (/[0-9]/.test(char)) {
				result += char;
			}
			// Все остальное (пробелы, знаки препинания и т.д.) - пропускаем
		}
		
		return result;
	}

	/**
	 * Применяет обработку к полю ввода
	 * @param {jQuery|HTMLElement} input - поле ввода
	 */
	applyToInput(input) {
		let _this = this;
		$(input).each(function() {
			// Проверяем, не применена ли уже обработка
			if ($(this).data('car-number-processed')) {
				return;
			}
			
			// Помечаем поле как обработанное
			$(this).data('car-number-processed', true);
			
			$(this).on('input', function() {
				let cursorPosition = this.selectionStart;
				let oldValue = this.value;
				let newValue = _this.transliterate(oldValue);
				
				// Если значение изменилось, обновляем
				if (oldValue !== newValue) {
					// Вычисляем новую позицию курсора
					// Считаем, сколько символов до курсора было обработано
					let processedBefore = _this.transliterate(oldValue.substring(0, cursorPosition));
					let newPosition = processedBefore.length;
					
					this.value = newValue;
					
					// Восстанавливаем позицию курсора
					this.setSelectionRange(newPosition, newPosition);
				}
			});
		});
	}

	/**
	 * Проверяет дубликат номера через AJAX и устанавливает setCustomValidity
	 * @param {HTMLElement} input - поле ввода
	 */
	checkDuplicate(input) {
		let _this = this;
		let timer = null;

		$(input).on('input', function() {
			let field = this;
			let number = field.value.trim();

			clearTimeout(timer);
			field.setCustomValidity('');

			if (!number) return;

			timer = setTimeout(function() {
				$.ajax({
					url: '/vsop/ajax/5/',
					data: { action: 'checkNumber', number: number },
					dataType: 'json',
					success: function(res) {
						if (res.exists) {
							field.setCustomValidity('Номер ' + number + ' уже имеет действующий пропуск (запись №' + res.id + ')');
							field.reportValidity();
						} else {
							field.setCustomValidity('');
						}
					}
				});
			}, 500);
		});
	}

	/**
	 * Применяет обработку ко всем нужным полям
	 */
	applyEvents() {
		// Поля в формах редактирования
		this.applyToInput('input[name=str_number]');

		// Поля фильтров на страницах модулей
		// mod_id=3 (журнал) - фильтр по номеру телефона/машины (search_1_1)
		// mod_id=5 (номера машин) - фильтр по номеру машины (search_1_0)
		let url = new URL(window.location.href);
		let modId = url.searchParams.get('selected_mod_id');
		let action = url.searchParams.get('action');

		if (modId === '3') {
			this.applyToInput('input[name="search_1_1"]');
		} else if (modId === '5') {
			this.applyToInput('input[name="search_1_0"]');
		}

		// Проверка дубликата только на странице добавления номера
		if (modId === '5' && action === 'add') {
			this.checkDuplicate('input[name=str_number]');
		}

		// Также применяем при загрузке документа (на случай, если поля загружаются динамически)
		let _this = this;
		$(document).ready(function() {
			_this.applyToInput('input[name=str_number]');
			if (modId === '3') {
				_this.applyToInput('input[name="search_1_1"]');
			} else if (modId === '5') {
				_this.applyToInput('input[name="search_1_0"]');
			}
			if (modId === '5' && action === 'add') {
				_this.checkDuplicate('input[name=str_number]');
			}
		});
	}
}
